module.exports = __webpack_public_path__ + "img/home.325220ce.svg";